import React from "react";
import { Calendar as CalendarIconOutline, ChevronLeft, ChevronRight, LayoutGrid, Plus } from "lucide-react";
import CustomDatePicker from "../../components/CustomDatePicker";
import ThemeTooltip from "../../components/ThemeTooltip";

export default function ScheduleToolbarControls({
  availableTypes,
  currentDate,
  currentDateStr,
  onAdd,
  onDateChange,
  onNextMonth,
  onPrevMonth,
  onSelectType,
  onSetViewMode,
  selectedType,
  theme,
  viewMode,
}) {
  return (
    <div className="sticky top-6 z-40 bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-lg border border-white/50 p-1.5 flex flex-col md:flex-row justify-between gap-2 transition-all duration-300 mb-3">
      <div className="flex-1 flex flex-wrap gap-2 items-center">
        <div className="flex bg-gray-100/80 rounded-[2rem] p-1 border border-gray-200/50 shadow-inner flex-shrink-0 h-11 items-center">
          <button onClick={onPrevMonth} className="w-9 h-9 flex items-center justify-center rounded-full text-gray-500 hover:bg-white hover:shadow-sm transition"><ChevronLeft size={18} /></button>
          <div className="px-2">
            <CustomDatePicker
              theme={theme}
              value={currentDateStr}
              onChange={onDateChange}
              type="month"
              customTrigger={
                <div className={`px-2 w-[100px] text-center cursor-pointer hover:${theme.text} transition font-black text-gray-700 whitespace-nowrap text-sm`}>
                  {currentDate.getFullYear()}년 {currentDate.getMonth() + 1}월
                </div>
              }
            />
          </div>
          <button onClick={onNextMonth} className="w-9 h-9 flex items-center justify-center rounded-full text-gray-500 hover:bg-white hover:shadow-sm transition"><ChevronRight size={18} /></button>
        </div>

        <div className="flex bg-white rounded-[2rem] p-[2px] border border-gray-200 shadow-sm flex-shrink-0 h-11 items-center overflow-x-auto custom-scrollbar px-1 gap-1">
          {availableTypes.map((type) => (
            <button
              key={type.id}
              onClick={() => onSelectType(type.id)}
              className={`px-3 py-1.5 rounded-[1.5rem] text-xs font-bold transition whitespace-nowrap flex items-center gap-1.5
                ${selectedType === type.id
                  ? `${type.activeClass} shadow-md`
                  : "text-gray-400 hover:text-gray-600 hover:bg-gray-50"
                }`}
            >
              {type.id === "worship" && <div className={`w-1.5 h-1.5 rounded-full ${selectedType === type.id ? "bg-white" : "bg-purple-500"}`}></div>}
              {type.id === "event" && <div className={`w-1.5 h-1.5 rounded-full ${selectedType === type.id ? "bg-white" : "bg-orange-500"}`}></div>}
              {type.id === "meeting" && <div className={`w-1.5 h-1.5 rounded-full ${selectedType === type.id ? "bg-white" : "bg-[#354F38]"}`}></div>}
              {type.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-2 relative z-0">
        <div className="flex bg-white rounded-[2rem] p-[2px] border border-gray-200 shadow-sm flex-shrink-0 items-center h-11 relative z-10">
          <ThemeTooltip theme={theme} text="달력형 보기">
            <button
              onClick={() => onSetViewMode("calendar")}
              className={`w-10 h-10 rounded-full transition-all border border-transparent flex items-center justify-center ${viewMode === "calendar" ? `${theme.lightBg} ${theme.text} ${theme.border.replace("border-", "border-").replace("]", "]/20")}` : "text-gray-400 hover:text-gray-600"}`}
            >
              <CalendarIconOutline size={18} />
            </button>
          </ThemeTooltip>
          <ThemeTooltip theme={theme} text="카드형 보기">
            <button
              onClick={() => onSetViewMode("card")}
              className={`w-10 h-10 rounded-full transition-all border border-transparent flex items-center justify-center ${viewMode === "card" ? `${theme.lightBg} ${theme.text} ${theme.border.replace("border-", "border-").replace("]", "]/20")}` : "text-gray-400 hover:text-gray-600"}`}
            >
              <LayoutGrid size={18} />
            </button>
          </ThemeTooltip>
        </div>

        <button onClick={onAdd} className={`${theme.bg} text-white px-5 h-11 rounded-[2rem] text-sm font-bold hover:opacity-90 transition flex items-center gap-2 flex-shrink-0 relative z-20`}>
          <Plus size={20} /> <span className="hidden sm:inline">일정 추가</span>
        </button>
      </div>
    </div>
  );
}
